import React from "react";

export default function MostPopularHeader() {
  return (
    <div className="absolute -top-8 left-1/2 -translate-x-1/2 bg-[#633EEA] text-white px-5 py-1 rounded-t-lg text-xs font-bold tracking-wider shadow-lg">
      MOST POPULAR
    </div>
  );
}
